/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type FirmDocumentReferenceTransferRequest = {
  document_reference_ids: Array<number>;
  target_measurement_date_id?: number | null;
  target_folder_id?: number | null;
  /**
   * Move firm documents between Firm Documents folders.
   */
  target_firm_level?: boolean;
  mode?: FirmDocumentReferenceTransferRequest.mode;
};
export namespace FirmDocumentReferenceTransferRequest {
  export enum mode {
    COPY = 'copy',
    MOVE = 'move',
  }
}

